import React from 'react';
import { useParams, useNavigate } from 'react-router';
import styles from './StoreGuide.module.scss';

// Import all JSX guide components
import SteamGuide from './guides/SteamGuide';
import EAPlayGuide from './guides/EAPlayGuide';
import RiotGamesGuide from './guides/RiotGamesGuide';
import EpicGamesGuide from './guides/EpicGamesGuide';
import UbisoftConnectGuide from './guides/UbisoftConnectGuide';
import RockstarSocialClubGuide from './guides/RockstarSocialClubGuide';
import GOGGuide from './guides/GOGGuide';

const StoreGuide: React.FC = () => {
  const { storeId } = useParams<{ storeId: string }>();
  const navigate = useNavigate();

  // Mapping of store IDs to guide components
  const getGuideComponent = () => {
    switch (storeId) {
      case 'steam':
        return <SteamGuide />;
      case 'ea-play':
        return <EAPlayGuide />;
      case 'riot-games':
        return <RiotGamesGuide />;
      case 'epic-games':
        return <EpicGamesGuide />;
      case 'ubisoft-connect':
        return <UbisoftConnectGuide />;
      case 'rockstar-social-club':
        return <RockstarSocialClubGuide />;
      case 'gog':
        return <GOGGuide />;
      default:
        return null;
    }
  };

  const guideComponent = getGuideComponent();

  const handleBackToGuides = () => {
    navigate('/activation-guides');
  };

  const handleBackToStore = () => {
    navigate('/');
  };

  if (!guideComponent) {
    return (
      <div className={styles.storeGuide}>
        <div className={styles.container}>
          <div className={styles.notFound}>
            <h1>Guide Not Found</h1>
            <p>The activation guide you're looking for doesn't exist.</p>
            <button onClick={handleBackToGuides} className={styles.backButton}>
              Back to Activation Guides
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.storeGuide}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.navigation}>
            <button 
              className={styles.backButton}
              onClick={handleBackToStore}
            >
              <img 
                src={`${process.env.PUBLIC_URL}/images/icons/back-arrow.svg`}
                alt="Back"
              />
              Back to Store
            </button>
            <button 
              className={styles.backToGuides}
              onClick={handleBackToGuides}
            >
              Back to All Guides
            </button>
          </div>
        </div>

        {guideComponent}
      </div>
    </div>
  );
};

export default StoreGuide; 